import { ProductStockViewModel } from '@models/api-search.models';
import { StoreViewModel } from '@models/api.models';

export const checkStoreStock = (
    storeStocks: ProductStockViewModel[] | undefined,
    selectedStore: StoreViewModel
): number => {
    const store = storeStocks?.find(stockStore => stockStore.storeId === selectedStore.storeId?.toString());
    if (store) {
        return store.stockQuantity;
    }
    return -1;
};
